import type { IComponentController } from '@wix/editor-elements-types/thunderbolt';

const compController: IComponentController = {
  mapStateToProps: ({ reducedMotion }) => ({
    reducedMotion,
  }),
};

export default compController;
